import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	sessionId: '',
    timestamp: 0,
  	started: false,
    showResults: false,
  	currentPart: 1,
    maxParts: 4,
    answers: []

  },
  mutations: {
  	SET_ID (state,id) {
      // mutate state
      state.sessionId = id
    },
    SET_STARTED(state) {
    	state.started = true
      state.timestamp = Date.now()
    },
    SET_SHOW_RESULTS(state) {
    	state.showResults = true
    },
    ADD_ANSWER(state,ans) {
      ans.userId = state.sessionId
      state.answers.push(ans)
    },
    NXT_PART(state){
        state.currentPart++
    }
  },
  actions: {
  	setId({ commit },newId){
  		commit('SET_ID',newId)
  	},
  	processStarted({ commit }){
  		commit('SET_STARTED')
  	},
    showResults({ commit }){
  		commit('SET_SHOW_RESULTS')
  	},
    addAnswer({ commit },answer){
      commit('ADD_ANSWER',answer)
    },
    nextPart({commit}){
      commit('NXT_PART')
    }
  },
  modules: {
  }
})
